"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ReactDOM = require("react-dom");
var ReactIs = require("react-is");
var prop_types_1 = require("prop-types");
var index_1 = require("playable/dist/src/index");
var PlayableSource = prop_types_1.exact({
    url: prop_types_1.string,
    type: prop_types_1.string,
});
var PropertyToMethodMap = {
    autoplay: 'setAutoplay',
    preload: 'setPreload',
    width: 'setWidth',
    height: 'setHeight',
    fillAllSpace: 'setFillAllSpace',
    src: 'setSrc',
    title: 'setTitle',
    poster: 'setPoster',
};
var ReactPlayable = /** @class */ (function (_super) {
    tslib_1.__extends(ReactPlayable, _super);
    function ReactPlayable(props) {
        var _this = _super.call(this, props) || this;
        _this.setWrapperRef = function (element) {
            _this._$wrapper = element;
        };
        _this.state = {
            isMounted: false,
        };
        return _this;
    }
    ReactPlayable.prototype.componentDidMount = function () {
        var _a = this.props, width = _a.width, height = _a.height, _b = _a.fillAllSpace, fillAllSpace = _b === void 0 ? false : _b, src = _a.src, _c = _a.autoplay, autoplay = _c === void 0 ? false : _c, _d = _a.preload, preload = _d === void 0 ? index_1.PRELOAD_TYPES.AUTO : _d, title = _a.title, poster = _a.poster, texts = _a.texts, _e = _a.config, _f = _e === void 0 ? {} : _e, _g = _f.modules, modules = _g === void 0 ? {} : _g, _h = _f.playbackAdapters, playbackAdapters = _h === void 0 ? [] : _h, _j = _f.disableControlWithClickOnPlayer, disableControlWithClickOnPlayer = _j === void 0 ? false : _j, _k = _f.disableControlWithKeyboard, disableControlWithKeyboard = _k === void 0 ? false : _k, _l = _f.disableFullScreen, disableFullScreen = _l === void 0 ? false : _l, _m = _f.nativeBrowserControls, nativeBrowserControls = _m === void 0 ? false : _m, _o = _f.hideMainUI, hideMainUI = _o === void 0 ? false : _o, _p = _f.hideOverlay, hideOverlay = _p === void 0 ? false : _p, onInit = _a.onInit;
        this.registerModules(modules);
        this.registerPlaybackAdapters(playbackAdapters);
        this._player = index_1.create({
            autoplay: autoplay,
            preload: preload,
            width: width,
            height: height,
            fillAllSpace: fillAllSpace,
            src: src,
            title: title,
            poster: poster,
            disableControlWithClickOnPlayer: disableControlWithClickOnPlayer,
            disableControlWithKeyboard: disableControlWithKeyboard,
            disableFullScreen: disableFullScreen,
            texts: texts,
            nativeBrowserControls: nativeBrowserControls,
            hideMainUI: hideMainUI,
            hideOverlay: hideOverlay,
        });
        this._player.attachToElement(this._$wrapper);
        onInit && onInit(this._player);
        this.setState({
            isMounted: true,
        });
    };
    ReactPlayable.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        Object.keys(this.props).forEach(function (property) {
            var method = PropertyToMethodMap[property] &&
                _this._player[PropertyToMethodMap[property]];
            if (method) {
                var newValue = _this.props[property];
                var oldValue = prevProps[property];
                if (newValue !== oldValue) {
                    method(newValue);
                }
            }
        });
    };
    ReactPlayable.prototype.componentWillUnmount = function () {
        this._player.destroy();
        this._player = null;
    };
    ReactPlayable.prototype.registerModules = function (modules) {
        if (modules === void 0) { modules = {}; }
        Object.keys(modules).forEach(function (moduleName) {
            return index_1.registerModule(moduleName, modules[moduleName]);
        });
    };
    ReactPlayable.prototype.registerPlaybackAdapters = function (adapters) {
        if (adapters === void 0) { adapters = []; }
        adapters.forEach(function (adapter) { return index_1.registerPlaybackAdapter(adapter); });
    };
    ReactPlayable.prototype.getExtendedChildren = function () {
        var _this = this;
        var children = this.props.children;
        return React.Children.map(children, function (child) {
            if (typeof child === 'boolean' ||
                typeof child === 'string' ||
                typeof child === 'number' ||
                ReactIs.isFragment(child) ||
                typeof child.type === 'string') {
                return child;
            }
            var constructor = child.type;
            if (constructor.dependencies) {
                var modules = constructor.dependencies.reduce(function (resolvedModules, moduleName) {
                    //@ts-ignore
                    resolvedModules[moduleName] = _this._player._scope.resolve(moduleName);
                    return resolvedModules;
                }, {});
                return React.cloneElement(child, modules);
            }
            return child;
        });
    };
    ReactPlayable.prototype.renderChildren = function () {
        return ReactDOM.createPortal(this.getExtendedChildren(), 
        //@ts-ignore
        this._player._defaultModules.rootContainer.getElement());
    };
    ReactPlayable.prototype.render = function () {
        var styles = this.props.fillAllSpace
            ? { width: '100%', height: '100%' }
            : {};
        return (React.createElement("section", { "data-hook": "react-playable", ref: this.setWrapperRef, style: styles }, this.state.isMounted ? this.renderChildren() : null));
    };
    ReactPlayable.propTypes = {
        width: prop_types_1.number,
        height: prop_types_1.number,
        fillAllSpace: prop_types_1.bool,
        src: prop_types_1.oneOfType([
            prop_types_1.string,
            PlayableSource,
            prop_types_1.arrayOf(prop_types_1.oneOfType([prop_types_1.string, PlayableSource])),
        ]),
        autoplay: prop_types_1.bool,
        preload: prop_types_1.oneOf([
            index_1.PRELOAD_TYPES.AUTO,
            index_1.PRELOAD_TYPES.METADATA,
            index_1.PRELOAD_TYPES.NONE,
        ]),
        title: prop_types_1.string,
        poster: prop_types_1.string,
        texts: prop_types_1.object,
        config: prop_types_1.shape({
            modules: prop_types_1.object,
            playbackAdapters: prop_types_1.array,
            hideMainUI: prop_types_1.bool,
            hideOverlay: prop_types_1.bool,
            disableControlWithKeyboard: prop_types_1.bool,
            disableControlWithClickOnPlayer: prop_types_1.bool,
            disableFullScreen: prop_types_1.bool,
            nativeBrowserControls: prop_types_1.bool,
        }),
        onInit: prop_types_1.func,
    };
    return ReactPlayable;
}(React.PureComponent));
exports.ReactPlayable = ReactPlayable;
//# sourceMappingURL=ReactPlayable.js.map